import React from 'react';

export function PageSkeleton() {
  return (
    <div className="min-h-screen bg-surface-secondary p-4 sm:p-6 lg:p-8 animate-pulse">
      {/* Header Skeleton */}
      <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-2">
          <div className="h-8 w-48 rounded-lg bg-surface-tertiary" />
          <div className="h-4 w-64 rounded bg-surface-tertiary" />
        </div>
        <div className="flex gap-3">
          <div className="h-10 w-28 rounded-lg bg-surface-tertiary" />
          <div className="h-10 w-32 rounded-lg bg-surface-tertiary" />
        </div>
      </div>

      {/* Cards Skeleton */}
      <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="rounded-xl border border-border bg-surface p-5 shadow-sm space-y-3"
          >
            <div className="flex items-center justify-between">
              <div className="h-4 w-24 rounded bg-surface-tertiary" />
              <div className="h-8 w-8 rounded-lg bg-surface-tertiary" />
            </div>
            <div className="h-7 w-36 rounded bg-surface-tertiary" />
            <div className="h-3 w-20 rounded bg-surface-tertiary" />
          </div>
        ))}
      </div>

      {/* Content / Table Skeleton */}
      <div className="rounded-xl border border-border bg-surface p-6 shadow-sm space-y-4">
        <div className="flex items-center justify-between border-b border-border pb-4">
          <div className="h-6 w-36 rounded bg-surface-tertiary" />
          <div className="h-9 w-48 rounded-lg bg-surface-tertiary" />
        </div>
        <div className="space-y-3 pt-2">
          {[1, 2, 3, 4, 5].map((row) => (
            <div key={row} className="flex items-center justify-between gap-4 py-2">
              <div className="h-4 w-1/4 rounded bg-surface-tertiary" />
              <div className="h-4 w-1/5 rounded bg-surface-tertiary" />
              <div className="h-4 w-1/6 rounded bg-surface-tertiary" />
              <div className="h-6 w-16 rounded-full bg-surface-tertiary" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
